export default __webpack_public_path__ + "locales/it/SmartBanner.json?hash=f963d67194691b273016cc8f68e558bc";